function blurFunc() {
  this.blur();
}

export default {
  name: 'disableTimePickerInput',
  mounted(el) {
    const inputs = [...el.querySelectorAll('.arco-picker-input>input')];
    if (inputs) {
      inputs.forEach((el) => el.addEventListener('focus', blurFunc));
      el._inputs = inputs; // Store reference to input element
    }
  },
  beforeUnmount(el) {
    if (el._inputs) {
      el._inputs.forEach((el) => el.removeEventListener('focus', blurFunc));
      el._inputs = null;
    }
  }
};
